import { ResetComponent } from './pages/auth/reset/reset.component';
import { AuthGuard } from './guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AccessGuard } from './guards/access.guard';

const routes: Routes = [
    {
        path: 'ir-taxation',
        loadChildren: () =>
            import('./pages/ir/ir.module').then((m) => m.IRModule),
        canActivate: [AuthGuard],
        canLoad: [AccessGuard],
    },
    {
        path: 'epargne',
        loadChildren: () =>
            import('./pages/epargne/epargne.module').then(
                (m) => m.EpargneModule
            ),
        canActivate: [AuthGuard],
        canLoad: [AccessGuard],
    },
    {
        path: 'life-insurance',
        loadChildren: () =>
            import('./pages/life-insurance/life-insurance.module').then(
                (m) => m.LifeInsuranceModule
            ),
        canActivate: [AuthGuard],
        canLoad: [AccessGuard],
    },
    {
        path: 'enr',
        loadChildren: () =>
            import('./pages/enr/enr.module').then((m) => m.EnrModule),
        canActivate: [AuthGuard],
        canLoad: [AccessGuard],
    },
    {
        path: 'stripping-annuity',
        loadChildren: () =>
            import('./pages/stripping-annuity/stripping-annuity.module').then(
                (m) => m.StrippingAnnuityModule
            ),
        canActivate: [AuthGuard],
        canLoad: [AccessGuard],
    },
    {
        path: 'auth',
        loadChildren: () =>
            import('./pages/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'account',
        loadChildren: () =>
            import('./pages/account/account.module').then(
                (m) => m.AccountModule
            ),
        canActivate: [AuthGuard],
    },
    {
        path: 'real-state',
        loadChildren: () =>
            import('./pages/real-state/real-state.module').then(
                (m) => m.RealStateModule
            ),
        canActivate: [AuthGuard],
        canLoad: [AccessGuard],
    },
    {
        path: 'actualisation',
        loadChildren: () =>
            import('./pages/actualisation/actualisation.module').then(
                (m) => m.ActualisationModule
            ),
        canActivate: [AuthGuard],
        canLoad: [AccessGuard],
    },
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'auth/reset', component: ResetComponent },
    {
        path: 'notification',
        loadChildren: () =>
            import('./pages/notification/notification.module').then(
                (m) => m.NotificationModule
            ),
        canActivate: [AuthGuard],
    },
    { path: '**', redirectTo: 'auth/signin' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
